export default __webpack_public_path__ + "static/media/image-artist.45107076.png";